import type { ShedInterest } from '../../../../../convex/shedInterests';

export type ShedRoute = { kind: 'home' | 'f2' | 'f4' | 'f4-thanks' } | { kind: 'interest'; interest: ShedInterest };
const table: Record<string, ShedRoute> = {
  '/': { kind: 'home' }, '/offers/deep-audit': { kind: 'f2' }, '/tools/handle-audit': { kind: 'f4' },
  '/tools/handle-audit/thanks': { kind: 'f4-thanks' }, '/the-editor': { kind: 'interest', interest: 'editor' },
  '/the-designer': { kind: 'interest', interest: 'designer' }, '/content-os': { kind: 'interest', interest: 'content-os' },
};
const protectedRoutes: Record<string, ShedRoute> = {
  'the-editor': { kind: 'interest', interest: 'editor' }, 'shed-deep-audit': { kind: 'f2' },
  // Deferred F1 bumps: neither is a standalone front door.
  'editor-hook-pack': { kind: 'interest', interest: 'editor' }, 'editor-style-pack': { kind: 'interest', interest: 'editor' },
  'the-designer': { kind: 'interest', interest: 'designer' }, 'content-os': { kind: 'interest', interest: 'content-os' },
};
for (const [sku, route] of Object.entries(protectedRoutes)) {
  table[`/p/${sku}`] = route; table[`/checkout/${sku}`] = route;
}
const lookup = (routes: Record<string, ShedRoute>, key: string): ShedRoute | null => Object.hasOwn(routes, key) ? routes[key] : null;

/** Exact routes only; preserve generic local query routes and member entry. */
export function parseShedRoute(pathname: string, search = ''): ShedRoute | null {
  const path = pathname.replace(/\/+$/, '') || '/';
  if (path === '/') {
    const q = new URLSearchParams(search), view = q.get('view');
    if (q.get('surface') === 'os') return null;
    if (view === 'shop') return null;
    if (view === 'checkout' || view === 'landing')
      return lookup(protectedRoutes, q.get(view === 'checkout' ? 'sku' : 'p') ?? '');
  }
  return lookup(table, path);
}
